export default "__VITE_ASSET__7f542527__"